/*
akhila        10/27/2022 2701251212  record format UX Changes
saikrishna 11/03/2022 2701251212 changed the paginationOptions
Ashraf 01/02/2022 2701251212 renamed usage header title

*/

import React, {useEffect, useContext} from 'react';
import capitalize from '../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import {resetUsageData} from '../../../../redux/reducers/BRE/AddRecordFormat';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {Button} from '@material-ui/core';
import {postPrintUsage, resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows, tablePageRows} from '../../../../constants/ReusableTablePagination';
import {modulesText} from '../../../../util/Content';

export default function MediaUsage({setValue}) {
  const {recordFormatUsageData, successMsg, errorMsg, isLoading, recordFormatRowData} =
    useSelector(({addRecordFormat}) => addRecordFormat);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  useEffect(() => {
    return () => {
      dispatch(resetUsageData());
    };
  }, []);
  useEffect(() => {
    if (printUsageErrorMsg || printUsageSuccessMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageErrorMsg, printUsageSuccessMsg]);

  const object = recordFormatUsageData?.placeResponse ? recordFormatUsageData?.placeResponse : {};
  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.codes?.length > 0 &&
        value?.codes?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el,
            description: value?.description?.[i] ?? '-',
          });
        });
    });

  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Code',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div>
      <div>
        <div className="button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
           Search Record Format
          </Button>
        </div>
        <div className="font-weight-bold">
          <div>
            <div className="custom-table custom-toolbar-icons">
              <GuiTable
                title={'This Record Format has been used in the following frameworks.'}
                columns={columns}
                data={values}
                textAlign="left"
                actions={[
                  {
                    icon: () => (
                      <>
                        <Button
                          type="button"
                          variant="contained"
                          className={`mx-1 themeing-buttons ${classes.buttonRoot}`}
                          color="primary"
                          disabled={!!(recordFormatUsageData.userMetrix === 'No')}
                          onClick={() => {
                            dispatch(
                              postPrintUsage({
                                baseCategory: '',
                                code: recordFormatRowData?.recordFormatCode ?
                                  recordFormatRowData.recordFormatCode :
                                  '',
                                description: recordFormatRowData?.description ?
                                  recordFormatRowData.description :
                                  '',
                                displayName: '',
                                fileType: recordFormatRowData?.type ? recordFormatRowData.type : '',
                                recordFormatType: recordFormatRowData?.frameWorkType,
                                returnType: '',
                                sourceType:
                                  recordFormatRowData?.frameWorkType === 'Enable' ?
                                    'ENABLE RECORD FORMAT' :
                                    'RECORD FORMAT',
                              }),
                            );
                          }}
                        >
                          Print Usage
                        </Button>
                      </>
                    ),
                    tooltip: 'Print Usage',
                    isFreeAction: true,
                    disabled: !!(recordFormatUsageData.userMetrix === 'No'),
                  },
                ]}
                options={{
                  paging: true,
                  toolbar: true,
                  search: true,
                  emptyRowsWhenPaging: false,
                  headerStyle: {
                    fontWeight: 'bold',
                    fontSize: '0.938rem',
                    padding: '16px',
                  },
                  pageSize: defaultRows,
                  pageSizeOptions: tablePageRows,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </div>
  );
}
